// Team satisfaction strip: per receptionist 👍 % from guest ratings after takeover chats.
import React, { useEffect, useState } from 'react';
import { ThumbsDown, ThumbsUp } from 'lucide-react';
import { apiCall } from './_shared';

export const useTeamScores = (days = 30) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    const tick = () => apiCall(`/api/admin/chat-live/scores?days=${days}`).then(setData).catch(() => {});
    tick();
    const id = setInterval(tick, 60000);
    return () => clearInterval(id);
  }, [days]);
  return data;
};

export const TeamScores = ({ data }) => {
  if (!data || !data.total) return <div className="text-xs text-slate-400 bg-white border rounded-xl px-3 py-2" data-testid="team-scores-empty">No guest ratings yet — guests get a 👍/👎 prompt when a takeover chat ends.</div>;
  const rows = (data.staff || []).map((row) => {
    const name = row.staff;
    const pct = row.pct_up;
    const cls = pct >= 80 ? 'bg-emerald-100 text-emerald-800' : (pct >= 50 ? 'bg-amber-100 text-amber-900' : 'bg-red-100 text-red-800');
    const comments = (row.comments || []).join(' · ');
    return (
      <div key={name} className="flex items-center gap-2 bg-white border rounded-lg px-3 py-1.5 text-xs" data-testid={`team-score-${name}`} title={comments}>
        <span className="font-bold text-slate-900">{name}</span>
        <span className={`px-1.5 py-0.5 rounded font-bold ${cls}`}>{pct}% 👍</span>
        <span className="text-slate-500 inline-flex items-center gap-1"><ThumbsUp className="w-3 h-3" /> {row.up} <ThumbsDown className="w-3 h-3 ml-1" /> {row.down}</span>
      </div>
    );
  });
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="team-scores">
      <span className="text-xs font-semibold text-slate-600">Team score · last {data.days} days · {data.pct_up}% 👍 of {data.total}</span>
      {rows}
    </div>
  );
};
